import { render } from "./PublicationReferralLink.vue.js?vue&type=template&id=ec06d17c!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationReferralLink.vue?vue&type=template&id=ec06d17c"
import script from "./PublicationReferralLink.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationReferralLink.vue?vue&type=script&lang=js"
export * from "./PublicationReferralLink.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationReferralLink.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/components/publication/PublicationReferralLink.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ec06d17c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ec06d17c', __exports__)) {
    api.reload('ec06d17c', __exports__)
  }
  
  module.hot.accept("./PublicationReferralLink.vue.js?vue&type=template&id=ec06d17c!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationReferralLink.vue?vue&type=template&id=ec06d17c", () => {
    api.rerender('ec06d17c', render)
  })

}


export default __exports__